import { CustomPageType } from '../../extViewmodels/sdk/models/CustomPageStyle';
import { useCustomPageStyleByShortCode } from '../queries/useCustomPageStyleByShortCode';
import { isInIframe } from '../utils/iframe';

export const useCustomPageStyle = (shortCode?: string, type: CustomPageType = CustomPageType.Header) => {
	const inIframe = isInIframe();

	const { data } = useCustomPageStyleByShortCode({
		shortCode,
		type,
		enabled: !!shortCode && !inIframe,
	});

	const hasCustomContent = !inIframe && !!data?.html;

	return {
		data,
		hasCustomContent,
		inIframe,
	};
};
